export default "__VITE_ASSET__CIRY$xUb__"